import styled from "styled-components";

import { theme } from "../../themes/themes";
export const BoxContainer = styled.div`
  margin: 10px;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;

  input {
    padding: 0.5em;
    width: 90%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    color: ${({ theme }) => theme.text.disabled};
    margin-bottom: 1em;
    background: ${({ theme }) => theme.background.tertiary};
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
  }

  input::placeholder {
    font-size: 12px;
  }

  label {
    padding-top: 1em;
    margin-bottom: 1em;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    font-family: "Noto Sans", sans-serif;
    font-style: normal;
  }
`;

export const TitleContainer = styled.span`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 25px;
  letter-spacing: 0.01em;
  color: #232323;
  margin-bottom: 25px;
  margin-top: 10px;
  grid-row: 1;
`;

export const ColorWrapper = styled.div`
  align-self: center;
  grid-row: 2;
  margin-bottom: 25px;
  .sketch-color {
    width: 100%;
  }
`;
